// @ts-check
import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';
import useFormStyles from '../../common/FormStyle';

const SimpleTextInput = ({ label, name, type, suf = '', placeHolder = '', numberFormated = false, ...props }) => {
  const formStyles = useFormStyles();
  const mv = (+props.value).toLocaleString();

  // TODO: create validation utility for all fields
  // const err = true

  const [editing, setEditing] = useState(false)

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-around"
        alignItems="center"
        marginY={1}
      >
        {label && <Typography className={clsx(formStyles.accordionTitle, formStyles.bold, formStyles.mypitem)}>
          {label}
        </Typography>}

        {!numberFormated &&
          <TextField className={formStyles.mysitem}
            // error={err}
            // helperText= {err && "Incorrect entry."}
            style={{
              width: "30%"
            }}
            placeholder={placeHolder}
            variant="outlined"
            size="small"
            type={type}
            // Ahmed: Not required
            onBlur={(e) => {
              console.log(e.target)
              setEditing(false)
              if (props.onBlur) props.onBlur(e)
            }}
            name={name}
            {...props}
            inputProps={{
              className: formStyles.inputField
            }}

          />
        }

        {numberFormated && editing &&
          <TextField className={formStyles.mysitem}
            // error={err}
            // helperText= {err && "Incorrect entry."}
            style={{
              width: "30%"
            }}
            placeholder={placeHolder}
            variant="outlined"
            size="small"
            type={type}
            name={name}
            {...props}
            inputProps={{
              className: formStyles.inputField
            }}
            onBlur={(e) => {
              console.log(e.target)
              setEditing(false)
              if (props.onBlur) props.onBlur(e)
            }}
          />
        }
        {numberFormated && !editing &&
          <TextField className={formStyles.mysitem}

            // error={err}
            // helperText= {err && "Incorrect entry."}
            style={{
              width: "30%"
            }}
            placeholder={placeHolder}
            variant="outlined"
            size="small"
            type='text'
            name={name}
            onFocus={() => setEditing(!editing)}
            {...props}
            value={(+props.value).toLocaleString()}
            inputProps={{
              className: formStyles.inputField
            }}
          />
        }
        {suf !== '' && <Typography className={clsx(formStyles.accordionTitle, formStyles.greyText, formStyles.mytitem)}>
          {suf}
        </Typography>}
      </Box>
    </>
  )
}

export default SimpleTextInput
